/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DashboardUseCaseModelCountShown
 */
export interface DashboardUseCaseModelCountShown {
  /**
   *
   * @type {number}
   * @memberof DashboardUseCaseModelCountShown
   */
  useCaseCount: number;
  /**
   *
   * @type {number}
   * @memberof DashboardUseCaseModelCountShown
   */
  modelCount: number;
}

/**
 * Check if a given object implements the DashboardUseCaseModelCountShown interface.
 */
export function instanceOfDashboardUseCaseModelCountShown(value: object): value is DashboardUseCaseModelCountShown {
  if (!('useCaseCount' in value) || value['useCaseCount'] === undefined) return false;
  if (!('modelCount' in value) || value['modelCount'] === undefined) return false;
  return true;
}

export function DashboardUseCaseModelCountShownFromJSON(json: any): DashboardUseCaseModelCountShown {
  return DashboardUseCaseModelCountShownFromJSONTyped(json, false);
}

export function DashboardUseCaseModelCountShownFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DashboardUseCaseModelCountShown {
  if (json == null) {
    return json;
  }
  return {
    useCaseCount: json['use_case_count'],
    modelCount: json['model_count'],
  };
}

export function DashboardUseCaseModelCountShownToJSON(value?: DashboardUseCaseModelCountShown | null): any {
  if (value == null) {
    return value;
  }
  return {
    use_case_count: value['useCaseCount'],
    model_count: value['modelCount'],
  };
}
